var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOriginLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56821 18.8C6.6147 18.847 6.67007 18.8843 6.73109 18.9098C6.79211 18.9353 6.85758 18.9484 6.92371 18.9484C6.98983 18.9484 7.0553 18.9353 7.11632 18.9098C7.17734 18.8843 7.23271 18.847 7.27921 18.8L19.0322 6.8C19.1238 6.70655 19.1752 6.58089 19.1752 6.45V1.155C19.1752 1.02239 19.1225 0.895214 19.0288 0.801445C18.935 0.707677 18.8078 0.654999 18.6752 0.654999L13.1242 0.660999C12.9917 0.661292 12.8647 0.714163 12.7712 0.807999L1.02921 12.551C0.93547 12.6448 0.882812 12.7719 0.882812 12.9045C0.882812 13.0371 0.93547 13.1642 1.02921 13.258L6.56821 18.8Z",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6748 5.655C16.5032 5.655 17.1748 4.98343 17.1748 4.155C17.1748 3.32657 16.5032 2.655 15.6748 2.655C14.8464 2.655 14.1748 3.32657 14.1748 4.155C14.1748 4.98343 14.8464 5.655 15.6748 5.655Z",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8283 20.0021C16.5787 20.2619 16.2798 20.4693 15.949 20.6121C15.6182 20.7549 15.2623 20.8303 14.902 20.8339C14.5418 20.8374 14.1844 20.7691 13.8509 20.6328C13.5174 20.4965 13.2144 20.2951 12.9597 20.0402C12.705 19.7854 12.5037 19.4823 12.3677 19.1487C12.2316 18.8151 12.1634 18.4578 12.1671 18.0975C12.1709 17.7372 12.2465 17.3813 12.3895 17.0507C12.5325 16.72 12.74 16.4211 13 16.1717L17.1712 12C17.6803 11.4942 18.3688 11.2104 19.0864 11.2104C19.8041 11.2104 20.4925 11.4942 21.0016 12V12C21.5076 12.509 21.7916 13.1975 21.7916 13.9152C21.7916 14.6329 21.5076 15.3214 21.0016 15.8304L16.8283 20.0021Z",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.085 14.085L18.9145 17.915",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7603 12.8817C17.915 12.7268 18.0988 12.604 18.301 12.5202C18.5033 12.4364 18.7201 12.3933 18.939 12.3933C19.1579 12.3933 19.3747 12.4364 19.577 12.5202C19.7792 12.604 19.963 12.7268 20.1178 12.8817",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOriginLabel);
export default __webpack_public_path__ + "static/media/OriginLabel.73217ebfdca452af792ffe7ea219384d.svg";
export { ForwardRef as ReactComponent };